export const SET_SIZE = "SET_SIZE";
export const SET_OS = "SET_OS";
export const INCREASE_SCORE = "INCREASE_SCORE";
export const DECREASE_SCORE = "DECREASE_SCORE";
export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const SET_AUTH_REDIRECT_PATH = "SET_AUTH_REDIRECT_PATH";
export const SET_USER_DATA = "SET_USER_DATA";
export const SET_CHECKED = "SET_CHECKED";
export const SET_TOURNAMENTS = "SET_TOURNAMENTS";
export const SET_SELECTED_TOURNAMENT = "SET_SELECTED_TOURNAMENT";
export const SET_CONTENTS = "SET_CONTENTS";
export const SET_SELECTED_CONTENT = "SET_SELECTED_CONTENT";
export const SET_MODE_HOME_PAGE = "SET_MODE_HOME_PAGE";
export const SET_MENU_STATUS = "SET_MENU_STATUS";
export const ADD_TOURNAMENT = "ADD_TOURNAMENT";
export const EDIT_TOURNAMENT = "EDIT_TOURNAMENT";
export const SET_OVER = "SET_OVER";
export const INCREASE_BALL = "INCREASE_BALL";
export const DECREASE_BALL = "DECREASE_BALL";
export const SET_AWAIT = "SET_AWAIT";
export const SET_HOME_SHOW_MODAL = "SET_HOME_SHOW_MODAL";
export const SET_EDIT_MODE = "SET_EDIT_MODE";
export const ADD_CONTENT = "ADD_CONTENT";
export const EDIT_CONTENT = "EDIT_CONTENT";
export const FOUL_HAPPEND = "FOUL_HAPPEND";
export const ADD_EVENT = "ADD_EVENT";
export const SWITCH_SERVER = "SWITCH_SERVER";
export const SWITCH_SIDE = "SWITCH_SIDE";
export const SET_SCOREBOARD_DATA = "SET_SCOREBOARD_DATA";
export const SET_CHOSEN = "SET_CHOSEN";
export const REMOVE_ITEM = "REMOVE_ITEM";
export const SET_GAME_ID = "SET_GAME_ID";
export const SET_SET_ID = "SET_SET_ID";
export const SET_SOCKET = "SET_SOCKET";
export const SET_SELECTED_GAME_VIEW = "SET_SELECTED_GAME_VIEW";
export const SET_SELECTED_GAME_REFEREE = "SET_SELECTED_GAME_REFEREE";
export const REMOVE_EVENT_FROM_STACK = "REMOVE_EVENT_FROM_STACK";
export const SET_PLAYER_PLACE = "SET_PLAYER_PLACE";
export const SET_ASSIGN_SCOREBOARD = "SET_ASSIGN_SCOREBOARD";
export const REMOVE_SCORES = "REMOVE_SCORES";
export const SET_IP = "SET_IP";
export const CLEAR_EVENTS_ADD_TOTAL_EVENTS = "CLEAR_EVENTS_ADD_TOTAL_EVENTS";
export const SETUP_EMPTY_SET_SCOREBOARD = "SETUP_EMPTY_SET_SCOREBOARD";
export const CLEANUP_SET_INFO = "CLEANUP_SET_INFO";
export const SETUP_MID_STAGE_SET_SCOREBOARD = "SETUP_MID_STAGE_SET_SCOREBOARD";
export const CHANGE_READY_STATUS = "CHANGE_READY_STATUS";
export const SET_MID_STAGE_STATUS = "SET_MID_STAGE_STATUS";
export const CHANGE_USER_INFO = "CHANGE_USER_INFO";
export const SWAP_PLAYERS = "SWAP_PLAYERS";
